import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const CreateReceptorAccountOnTicketStamping = ({ data = {}, isValid = false, onFormDataChange }) => {

  useEffect(() => {
    onFormDataChange({
      data: {
        ...data,
        external: false
      },
      isValid: isValid
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnChange = (event) => {
    const { checked } = event.target;

    onFormDataChange({
      data: {
        ...data,
        external: checked ? true : false
      },
      isValid: isValid
    });
  }


  return (
    <Row>
      <Col>
        <Form.Check
          type='checkbox'
          id="external"
          name="external"
          label="Crear una cuenta en el portal de facturación"
          value="true"
          custom={ true }
          checked={ !!data.external }
          onChange={ handleOnChange }
        />
        <Form.Text className="text-muted">
          Al aceptar tendrás acceso a tus tickets y tus facturas dentro de nuestro portal. Nunca compartiremos tu email con nadie.
        </Form.Text>
      </Col>
    </Row>
  );
}

export default CreateReceptorAccountOnTicketStamping;
